import { motion } from "framer-motion";
import { ACTIONS } from "../../lib/admin";

const n = (v, one, many) => `${v} ${v === 1 ? one : many}`;

export const StatCards = ({ data }) => {
  const by = data?.by_action ?? {};
  const cards = [
    { key: "view", value: by.view?.unique ?? 0, hint: n(by.view?.total ?? 0, "carregamento", "carregamentos") },
    { key: "subscribe", value: by.subscribe?.unique ?? 0, hint: n(by.subscribe?.total ?? 0, "clique", "cliques") },
    { key: "decline", value: by.decline?.unique ?? 0, hint: n(by.decline?.total ?? 0, "clique", "cliques") },
    { key: "support", value: by.support?.unique ?? 0, hint: n(by.support?.total ?? 0, "clique", "cliques") },
  ];
  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
      <motion.div data-testid="stat-conversion" className="ad-card ad-conv col-span-2 lg:col-span-1 p-5"
        initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}>
        <p className="ad-label !text-[#0A140E]">Conversão</p>
        <p className="ad-num">{String(data?.conversion ?? 0).replace(".", ",")}<small>%</small></p>
        <p className="text-xs font-semibold text-[#0A140E]/75">visitantes que clicaram em assinar</p>
      </motion.div>
      {cards.map((c, i) => (
        <motion.div key={c.key} data-testid={`stat-${c.key}`} className="ad-card p-5"
          initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.05 * (i + 1) }}>
          <p className="ad-label flex items-center gap-2">
            <i className="w-2 h-2 rounded-full inline-block" style={{ background: ACTIONS[c.key].color }} />
            {ACTIONS[c.key].label}
          </p>
          <p className="ad-num">{c.value}</p>
          <p className="text-xs text-[#9DB0A5]">{c.hint}</p>
        </motion.div>
      ))}
    </div>
  );
};
